import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _Alarmclock(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsxs("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: [_jsx("circle", { cx: 12, cy: 13, r: 7, stroke: "currentColor", strokeWidth: 2 }), _jsx("path", { stroke: "currentColor", strokeLinecap: "round", strokeWidth: 2, d: "M5 5 3 7M19 5l2 2M9 11l2.81 1.873a.25.25 0 0 0 .333-.052L14 10.5" })] }) });
}
const Alarmclock = forwardRef(_Alarmclock);
export { Alarmclock };
